import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {User, UserRole} from '../../../../core/models/user';
import {AuthUser, TokenService} from '../../../../core/auth';
import {UserService} from '../../../../core/services/user.service';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {SelectItem} from 'primeng/api';
import {EventService} from '../../../../core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserActivationService} from '../../../../core/services';
import {UserActivationRequest} from '../../../../core/models';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'app-user-activation',
    templateUrl: './user-activation.component.html'
})
export class UserActivationComponent implements OnInit {

    @Input() display;
    @Input() mode;
    @Input() token;

    loading = true;
    error = false;
    busy = true;

    validPassword: boolean;
    newPassword: string;
    confirmPassword: string;

    user: User;

    constructor(
        private userService: UserService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private tokenService: TokenService,
        private eventService: EventService,
        private formBuilder: FormBuilder,
        private userActivationService: UserActivationService
    ) {
    }

    ngOnInit() {
        if (this.display) {
            this.loading = true;
            this.userActivationService.getUser(this.token).subscribe(
                (user) => {
                    this.user = user;
                    this.error = false;
                    this.busy = false;
                    this.loading = false;
                },
                (error) => {
                    this.error = true;
                    this.busy = false;
                    this.loading = false;
                });
        }
    }

    goToLogin() {
        this.display = false;
        this.router.navigate(['/login']);
    }

    cancel() {
        this.goToLogin();
    }

    passwordChanged(isOk) {
        this.validPassword = isOk;
    }

    activateUser() {
        if (this.validPassword) {
            this.busy = true;
            this.user.password = this.newPassword;
            const userActivationRequest = new UserActivationRequest(this.user.email, this.confirmPassword);
            this.userActivationService.activateUser(this.token, userActivationRequest, this.mode)
                .subscribe(
                    (data) => {
                        this.goToLogin();
                        this.busy = false;
                    },
                    (error) => {
                        this.busy = false;
                        this.error = true;
                    });
        }
    }

}
